import service from "../services/oficios.service"; // Asegúrate de que el servicio esté configurado correctamente

export const oficios = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async getOficios() { 
            try {
                const response = await service.getOficios();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save(context,data) {  
            try {
                const response = await service.createData(data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async delete(context, id) {
            try {
                const response = await service.deleteData(id);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
    },
    mutations: {
    },
};
